import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ToastHelper from 'general/helpers/ToastHelper';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import AgencyHelper from 'features/Agency/agencyHelper';
import AppColors from 'general/constants/AppColors';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';

DialogCreateVoucherView.propTypes = {
  item: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogCreateVoucherView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);

  // MARK: ---- METHODS ----

  const handleSubmit = async () => {
    setLoading(true);

    const param = {
      voucherBatchId: item?.voucherBatchId,
    };

    const res = await AgencyHelper.API.requestReleaseVoucherBatch(param);

    if (res && _.isBoolean(res)) {
      ToastHelper.showSuccess('Tạo voucher thành công');
      onDone?.();
    } else {
      ToastHelper.showError(res);
    }

    setLoading(false);
  };

  return (
    <div>
      <div className="d-flex flex-column align-item-center justify-content-center text-center px-5 pt-6 gap-2">
        <div className="mb-4">
          <img src={AppResource.images.dialogIcons.dialogReleaseVoucherBatch} alt="Release Voucher" />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Tạo voucher
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Bạn có chắc muốn tạo voucher cho lô voucher {' '}
          <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
          >{item?.voucherBatchCode ?? `VP${item?.voucherBatchId?.toString().padStart(8, '0')}`}</span>{' '}
          không?
        </span>
      </div>

      <div className="row m-0 mt-3 p-0 px-3">
        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel('Số lượng voucher', true)}
          <KTFormInput
            name="value"
            placeholder="Nhập số"
            type={KTFormInputType.number}
            value={item?.quantity}
            onChange={(value) => setValue(value)}
            disabled={true}
          />
        </div>
      </div>

      <div
        className="d-flex align-item-center gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        <div className="flex-fill">
          {UIHelper.buildNegativeButton('Hủy bỏ', onCancel)}
        </div>

        <div className="flex-fill">
          {UIHelper.buildGreenButton('Tạo voucher', handleSubmit, null, false, loading)}
        </div>
      </div>
    </div>
  );
}

export default DialogCreateVoucherView;